import StockSubsectionPlaceholder from "../../../components/StockSubsectionPlaceholder";

export default function PedidoSugeridoPage() {
  return (
    <StockSubsectionPlaceholder
      sectionPath="analisis"
      subsectionPath="pedido-sugerido"
    />
  );
}
